import request from '@/util/request';

/**
 * 版权交易金融服务银行 接口
 * @Author Hubx
 */

// 免登录 获取详情
export function financeBankInfo(id) {
  return request({
    url: `/tran/TranFinanceBank/ua/` + id,
    method: 'get'
  });
}

// 免登录 获取列表
export function financeBankList(params) {
  return request({
    url: `/tran/TranFinanceBank/ua/list`,
    method: 'get',
    params: params
  });
}

// 免登录 保存记录
export function financeBankSave(data) {
  return request({
    url: `/tran/TranFinanceBank/ua/saveOrUpdate`,
    method: 'post',
    data: data
  });
}
